import fluidvids from "fluidvids.js";

export default class ResponsiveVideos {
  static init() {
    fluidvids.init({
      selector: ["iframe", "object"],
      players: [
        "youtube.com",
        "www.youtube.com",
        "player.vimeo.com",
        "youtube-nocookie.com",
      ],
    });
  }
}
